<template>
  <el-col v-if="buttonList != null && buttonList.length > 0" :span="24" class="toolbar" style="padding-bottom: 0px;">
    <el-form :inline="true" @submit.native.prevent>
      <el-form-item label="公交线路" prop="busLinesId" label-width="80px">
        <el-select style="width: 150px;" @change="selectChanged" v-model="busLinesId" clearable placeholder="请选择公交线路">
          <el-option v-for="item in busLiness" :key="item.Id" :value="item.Id" :label="item.LineChineseName">
            <span style="float: left">{{ item.LineChineseName }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button
          :type="item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'"
          v-if="!item.IsHide" @click="callFunc(item)">{{ item.name }}</el-button>
      </el-form-item>
    </el-form>
  </el-col>
</template>
<script>
import { getBusLinesListPage, getBusLineDirectionByBusLinesId } from "../../api/api";

export default {
  name: "SiteToolbar",
  data() {
    return {
      busLiness: [], //线路列表
      sites: [], //站点列表
      busLinesId: "", //线路ID
      busLineDirectionName: "", //线路方向中文名称
      siteName: "" //双向绑定搜索内容
    };
  },
  props: ["buttonList"], //接受父组件传值
  methods: {
    callFunc(item) {
      item.siteName = this.siteName;
      item.busLinesId = this.busLinesId;
      item.busLineDirectionName = this.busLineDirectionName;
      this.$emit("callFunction", item); //将值传给父组件
    },
    selectChanged(value) {
      this.sites = [];
      this.busLineDirectionName = "";
      if (value !== "")
        this.getBusLineDirection();
    },
    getBusLineDirection() {
      let para = {
        busLinesId: this.busLinesId
      };
      getBusLineDirectionByBusLinesId(para).then(res => {
        this.sites = res.data.data;
      });
    }
  },
  mounted() {
    let pageSizePara = {
      pageSize: 100
    };
    getBusLinesListPage(pageSizePara).then(res => {
      this.busLiness = res.data.response.data;
    });
  }
};
</script>